module.exports = __webpack_public_path__ + "static/landing-page-video-screenshot@2x-d499e35edcde3bb3e061c9804ddaca13.jpg";